import React from 'react';
import { bellimage } from '../../paths/defaultImage';
import LazyImage from './lazyLoad';

const BellIcon = ({ openDrawer }) => {
  const clickHandler = () => {
    if (typeof openDrawer == 'function') openDrawer();
  };

  return <LazyImage src={bellimage} alt='bell' height={28} width={28} onClick={clickHandler} />;
};

export default BellIcon;
